import React from "react";
import "./CheckEligibilityBanner.css";
import { Button, useMediaQuery } from "@mui/material";

const CheckEligibilityBanner = () => {
  const isSmallScreen = useMediaQuery(" (max-width:576px) ");
  const isMediumScreen = useMediaQuery(" (max-width:768px) ");
  return (
    <>
      <div
        style={{
          backgroundColor: "#E7E4F9",
          borderRadius: 5,
          padding: isSmallScreen ? 30 : 40,
          marginTop: "10%",
          marginBottom: "4%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            backgroundColor: "transparent",
          }}
        >
          <p
            className="minutes"
            style={{
              color: "#59266D",
              backgroundColor: "transparent",
              fontFamily: "Archivo",
              fontSize: isMediumScreen ? 28 : 32,
              lineHeight: isSmallScreen ? "34px" : "36px",
              fontWeight: 600,
            }}
          >
            Confused about car loan eligibility?
          </p>
          <p
            style={{
              color: "#59266D",
              backgroundColor: "transparent",
              fontFamily: "Archivo",
              fontSize: isSmallScreen ? 16 : 18,
              lineHeight: isSmallScreen ? "20px" : "24px",

              fontWeight: 400,
            }}
          >
            Visit our Car Loan Eligibility Guide for detailed insights.
          </p>
          <div className=" ">
            <Button
              sx={{
                backgroundColor: "#553285",
                "&:hover": {
                  backgroundColor: "#7a46a3",
                },
                color: "white",
                borderRadius: 2,
                padding: "5px 30px",
                fontFamily: "Archivo",
                fontWeight: 500,
                fontSize: isSmallScreen ? 16 : 18,
                lineHeight: isSmallScreen ? "20px" : "24px",
                textTransform: "none",
              }}
              onClick={() => {
                window.location.href = "https://minemi.ai/best-car-loan-offer";
              }}
            >
               Check Your Eligibility Now
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckEligibilityBanner;
